import React from 'react'

const Amz3 = () => {
    return (
        <div>
               <div class="tabs">
    <input type="radio" name="tab" id="tab1" />
    <label for="tab1">C</label>
    <input type="radio" name="tab" id="tab2"/>
    <label for="tab2">CPP </label>
    <input type="radio" name="tab" id="tab3"/>
    <label for="tab3">Python</label>
    <input type="radio" name="tab" id="tab4"/>
    <label for="tab4">Java</label>
  
    <div class="tab-content-wrapper">
      <div id="tab-content-1" class="tab-content">
      </div>
      <div id="tab-content-2" class="tab-content">
     </div>
      <div id="tab-content-3" class="tab-content">
    </div>
      <div id="tab-content-4" class="tab-content">
        </div>
    </div>
  </div>
        </div>
    )
}

export default Amz3
